__turbopack_context__.v({
  "workspaceDiscoverySection": "k4Bm9q_workspaceDiscoverySection",
});
